import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, ValueGetterParams } from 'ag-grid-community';

@Component({
  selector: 'app-stacked-text-renderer',
  templateUrl: './stacked-text-renderer.component.html',
  styleUrls: ['./stacked-text-renderer.component.css'],
})
export class StackedTextRendererComponent implements ICellRendererAngularComp {
  bottomText!: string;

  topText!: string;

  displayBadge = false;

  emptyText!: string;

  // gets called once before the renderer is used
  agInit(params: StackedTextRendererParams): void {
    if (params.valueHandler) {
      [this.topText, this.bottomText] = params.valueHandler(params.data);
    } else {
      if (params.bottomElement in params.data)
        this.bottomText = params.data[params.bottomElement];
      if (params.topElement in params.data)
        this.topText = params.data[params.topElement];
    }
    this.displayBadge = params.dangerBadgeIfEmpty;
    this.emptyText = params.emptyText;
  }

  // gets called whenever the cell refreshes
  refresh(params: ICellRendererParams): boolean {
    return true;
  }
}

export type StackedTextRendererParams = ICellRendererParams & {
  topElement: string;
  bottomElement: string;
  dangerBadgeIfEmpty: boolean;
  emptyText: string;
  valueHandler: (data: ValueGetterParams['data']) => [string, string];
};
